import React from 'react';

import Link from '@components/i18n/Link';
import { TermsText } from './Terms.styles';

const Terms = ({ language, dark = false, reserve }) =>
  // If reservation type....
  reserve === true && language === 'ar' ? (
    <TermsText dark={!!dark}>
      {' '}
      بموجب إرسال هذا النموذج، أنت تقر بالموافقة على
      <a
        href="/files/lucid-air-reservation-terms-conditions_20201216.pdf"
        target="_blank"
        rel="noopener"
      >
        اتفاقية حجز Lucid
      </a>
      ، و
      <Link to={`/legal#terms-of-use`} target="_blank">
        شروط الاستخدام
      </Link>
      ، و
      <Link to={`/legal#privacy-policy`} target="_blank">
        سياسة الخصوصية
      </Link>
      .
    </TermsText>
  ) : // If reservation type...
  reserve === true && language === 'en-ca' ? (
    <TermsText dark={!!dark}>
      By submitting this form, you agree to our{' '}
      <a
        href="/files/lucid-air-reservation-terms-conditions_ca_20211013.pdf"
        target="_blank"
        rel="noopener"
      >
        Lucid Reservation Agreement
      </a>
      ,{' '}
      <Link to={`/legal#terms-of-use`} target="_blank">
        Terms of Use
      </Link>{' '}
      and our{' '}
      <Link to={`/legal#privacy-policy`} target="_blank">
        Privacy Policy
      </Link>
      .
    </TermsText>
  ) : // If reservation type...
  reserve === true ? (
    <TermsText dark={!!dark}>
      By submitting this form, you agree to our{' '}
      <a
        href="/files/lucid-air-reservation-terms-conditions_20201216.pdf"
        target="_blank"
        rel="noopener"
      >
        Lucid Reservation Agreement
      </a>
      ,{' '}
      <Link to={`/legal#terms-of-use`} target="_blank">
        Terms of Use
      </Link>{' '}
      and our{' '}
      <Link to={`/legal#privacy-policy`} target="_blank">
        Privacy Policy
      </Link>
      .
    </TermsText>
  ) : // English
  language == 'en' ? (
    <TermsText dark={!!dark}>
      By submitting this form, you agree to our{' '}
      <Link to={`/legal#terms-of-use`} target="_blank">
        Terms of Use
      </Link>{' '}
      and our{' '}
      <Link to={`/legal#privacy-policy`} target="_blank">
        Privacy Policy
      </Link>
      .
    </TermsText>
  ) : // Arabic
  language == 'ar' ? (
    <TermsText dark={!!dark}>
      بموجب إرسال هذا النموذج، أنت تقر بالموافقة على{' '}
      <Link to={`/legal#terms-of-use`} target="_blank">
         شروط الاستخدام
      </Link>{' '}
      و
      <Link to={`/legal#privacy-policy`} target="_blank">
        سياسة الخصوصية
      </Link>
      .
    </TermsText>
  ) : // Chinese
  language == 'zh' ? (
    <TermsText dark={!!dark}>
      By submitting this form, you agree to our{' '}
      <Link to={`/legal#terms-of-use`} target="_blank">
        Terms of Use
      </Link>{' '}
      and our{' '}
      <Link to={`/legal#privacy-policy`} target="_blank">
        Privacy Policy
      </Link>
      .
    </TermsText>
  ) : (
    // Fallback -- English
    <TermsText dark={!!dark}>
      By submitting this form, you agree to our{' '}
      <Link to={`/legal#terms-of-use`} target="_blank">
        Terms of Use
      </Link>{' '}
      and our{' '}
      <Link to={`/legal#privacy-policy`} target="_blank">
        Privacy Policy
      </Link>
      .
    </TermsText>
  );

export default Terms;
